import React from 'react';
import { motion } from 'framer-motion';
import FadeIn from './shared/FadeIn';
import { SKILLS } from '../data/skills';

const Skills = () => (
  <FadeIn id="skills" className="py-28 bg-raised/30 content-auto">
    <div className="max-w-6xl mx-auto px-6">
      <div className="mb-12">
        <span className="text-xs font-mono text-green/50 tracking-widest mb-3 block" aria-hidden="true">01</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-3">Technical Skills</h2>
        <p className="text-txt-secondary text-lg">Tools and technologies I work with</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 lg:gap-x-16 gap-y-8">
        {SKILLS.map((skill, i) => (
          <motion.div
            key={skill.category}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
          >
            <h3 className="text-xs font-mono font-medium text-green mb-3 uppercase tracking-widest">
              {skill.category}
            </h3>
            <div className="flex flex-wrap gap-2">
              {skill.items.map((item) => (
                <span
                  key={item}
                  className="text-sm font-mono px-3 py-1.5 bg-surface border border-border rounded-md text-txt-secondary"
                >
                  {item}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </FadeIn>
);

export default Skills;
